/* eslint-disable react/display-name */
// * You should NOT edit this file directly. Read CONTRIBUTING.md for more information on creating icons
import { __assign } from "tslib";
import React from 'react';
import { forwardRef } from '../../helpers/forwardRef';
import { BaseIcon } from '../../internal/BaseIcon';
export var ScanBarcodeClassicIcon20Solid = forwardRef('ScanBarcodeClassicIcon20Solid', function (props, ref) {
    return (React.createElement(BaseIcon, __assign({ ref: ref, viewBoxSize: 20 }, props),
        React.createElement("path", { d: "M3.649 4.375a.9.9 0 0 0-1.8 0v11.25a.9.9 0 0 0 1.8 0V4.375Z" }),
        React.createElement("path", { d: "M5.65 3.475a.9.9 0 0 1 .9.9v9.321a.9.9 0 1 1-1.8 0V4.375a.9.9 0 0 1 .9-.9Z" }),
        React.createElement("path", { d: "M9.45 4.375a.9.9 0 0 0-1.8 0v9.321a.9.9 0 1 0 1.8 0V4.375Z" }),
        React.createElement("path", { d: "M11.45 3.475a.9.9 0 0 1 .9.9v11.25a.9.9 0 0 1-1.8 0V4.375a.9.9 0 0 1 .9-.9Z" }),
        React.createElement("path", { d: "M15.251 4.375a.9.9 0 1 0-1.8 0v9.321a.9.9 0 0 0 1.8 0V4.375Z" }),
        React.createElement("path", { d: "M18.152 4.375a.9.9 0 1 0-1.8 0v11.25a.9.9 0 0 0 1.8 0V4.375Z" })));
});
